import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import { useAccountsDataContext } from "./accounts-data-provider";

type DuplicateAccount = {
  accountName: string;
  accountNo: string;
};

export const DuplicateNamesWarning = () => {
  const { accounts } = useAccountsDataContext();

  // Find duplicated account names (case-insensitive, trimmed)
  const findDuplicateNames = () => {
    const nameCounts = new Map<string, DuplicateAccount[]>();

    accounts.forEach((account) => {
      const trimmedName = account.accountName.trim().toLowerCase();
      if (!nameCounts.has(trimmedName)) {
        nameCounts.set(trimmedName, []);
      }
      nameCounts.get(trimmedName)?.push({
        accountName: account.accountName,
        accountNo: account.accountNo,
      });
    });

    const duplicates = new Map<string, DuplicateAccount[]>();
    nameCounts.forEach((accountList, trimmedName) => {
      if (accountList.length > 1) {
        // Use the first occurrence's name as the key for display
        duplicates.set(accountList[0].accountName, accountList);
      }
    });

    return duplicates;
  };

  const duplicateNames = findDuplicateNames();

  if (duplicateNames.size === 0) {
    return null;
  }

  return (
    <div className="mb-4 p-4 bg-orange-50 border border-orange-200 rounded-lg">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon className="h-6 w-6 text-orange-600" />
        </div>
        <div className="flex-1">
          <h4 className="text-sm font-medium text-orange-800 mb-1">
            Duplizierte Kontennamen gefunden
          </h4>
          <p className="text-sm text-orange-700 mb-2">
            Die folgenden Kontennamen sind mehrfach vorhanden:
          </p>
          <ul className="space-y-1">
            {Array.from(duplicateNames.entries()).map(
              ([displayName, accountList]) => {
                const accountNumbers = accountList
                  .map((acc) => acc.accountNo)
                  .join(" / ");
                return (
                  <li key={displayName} className="text-sm text-orange-700">
                    <span className="font-medium">
                      {displayName} - {accountNumbers}
                    </span>
                  </li>
                );
              },
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
